import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-contact-card',
    templateUrl: './contact-card.component.html',
    styleUrls: ['./contact-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactCardComponent implements OnInit, AfterViewInit {

  faEllipsisV = faEllipsisV;

  @Input()
  header: string = null;

  @Input()
  name: string = null;

  @Input()
  photo: string = null;

  @Input()
  job: string = null;

  @Input()
  phone: string = null;

  @Input()
  email: string = null;

  @Input()
  site: string = null;

  @ViewChild('actionsWrapper') actionsWrapper: ElementRef;

  hasActions = false;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.hasActions = Array.from(this.actionsWrapper.nativeElement.childNodes).filter((el: Node) => el.nodeName != '#comment').length > 0;
    });
  }

  goToLink(site: string) {
    let url = site;
    if (!site.includes("//")) {
      url = "//" + site;
    }

    window.open(url, '_blank');
  }
}
